/**
 * Configuração da API de Upload
 * 
 * IMPORTANTE: Altere a URL abaixo para a URL real da sua API após hospedar
 */

// URL da API de Upload
// Desenvolvimento local: 'http://localhost/api-upload/upload.php'
// Produção: 'https://api.seudominio.com.br/upload.php'
export const API_UPLOAD_URL = 'https://api.taiapp.com.br/upload.php';

// Configurações de upload
export const UPLOAD_CONFIG = {
  maxFileSize: 10 * 1024 * 1024, // 10MB
  allowedTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'audio/mpeg', 'audio/mp3'],
  allowedExtensions: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'mp3'],
};

// URL das Cloud Functions (substituir pelo URL de deploy)
// Padrão: https://us-central1-<project-id>.cloudfunctions.net
export const FUNCTIONS_URL = 'https://us-central1-talk-about-it-789ff.cloudfunctions.net';

/**
 * Normaliza URLs de mídia: converte http→https e corrige barras duplas no path
 */
export function normalizeMediaUrl(url) {
  if (!url) return url;
  return url
    .replace(/^http:\/\//, 'https://')
    .replace(/(https?:\/\/)([^/]+)(\/\/+)/g, '$1$2/');
}
